/* ============================================================
   artvision® · Zahlweise monatlich / jährlich (KV-04)
   Ein Bereich [data-av-billing-scope] trägt die aktuelle Wahl in
   data-av-billing ("yearly" | "monthly"). Darin:
     [data-av-billing-opt="…"]   Umschalter (role="radio")
     [data-av-billing-show="…"]  nur bei dieser Zahlweise sichtbar (CSS)
     a[data-av-billing-href]     bekommt ?billing=… angehängt
     [data-av-plan-yearly] / [data-av-plan-monthly]
                                 setzt das innere input[name=selling_plan] auf den
                                 passenden Abo-Plan (Appstle)
   Startwert: ?billing= in der Adresse, sonst die Wahl dieser Sitzung,
   sonst die Vorgabe im Markup. Die Wahl wandert per sessionStorage
   bis in die Bewerbung.
   ============================================================ */
(function () {
  var KEY = 'av:apply:billing';
  var MODES = { yearly: 1, monthly: 1 };

  /* Freischalt-Link (av-pkg-unlock.js): feste Zahlweise, kein Wechsel */
  function locked() {
    var m = document.documentElement.getAttribute('data-av-billing-lock');
    return MODES[m] ? m : '';
  }

  function initial(fallback) {
    if (locked()) return locked();
    /* Getrennte Produkte für jährlich und monatlich: Die Seite selbst
       legt die Zahlweise fest, eine frühere Wahl darf sie nicht
       überschreiben (sonst zeigte die Monatsseite den Jahrespreis). */
    var fixed = document.querySelector('[data-av-billing-fixed]');
    if (fixed && MODES[fixed.getAttribute('data-av-billing-fixed')]) return fixed.getAttribute('data-av-billing-fixed');
    var m = '';
    try { m = (new URLSearchParams(window.location.search).get('billing') || '').toLowerCase(); } catch (e) { m = ''; }
    if (!MODES[m]) { try { m = sessionStorage.getItem(KEY) || ''; } catch (e) { m = ''; } }
    return MODES[m] ? m : fallback;
  }

  function apply(scope, mode, focus) {
    scope.setAttribute('data-av-billing', mode);
    scope.querySelectorAll('[data-av-billing-opt]').forEach(function (b) {
      var on = b.getAttribute('data-av-billing-opt') === mode;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on && focus) b.focus();
    });
    scope.querySelectorAll('a[data-av-billing-href]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.href);
        u.searchParams.set('billing', mode);
        a.setAttribute('href', u.origin === window.location.origin ? u.pathname + u.search + u.hash : u.href);
      } catch (e) { /* Link bleibt */ }
    });
    scope.querySelectorAll('[data-av-plan-' + mode + ']').forEach(function (w) {
      var id = w.getAttribute('data-av-plan-' + mode);
      w.querySelectorAll('input[name="selling_plan"]').forEach(function (input) { if (id) input.value = id; });
    });
    try { sessionStorage.setItem(KEY, mode); } catch (e) { /* ohne Sitzung */ }
  }

  /* Eine Wahl gilt für die ganze Seite (Kopf und Abschluss einer
     Paketseite zeigen dieselbe Zahlweise). */
  function applyAll(mode, origin, focus) {
    document.querySelectorAll('[data-av-billing-scope]').forEach(function (s) {
      apply(s, mode, focus && s === origin);
    });
  }

  function init(scope) {
    if (scope.__avBilling) return;
    scope.__avBilling = true;
    var mode = initial(scope.getAttribute('data-av-billing') || 'yearly');
    apply(scope, mode);
    scope.addEventListener('click', function (e) {
      var b = e.target.closest('[data-av-billing-opt]');
      if (locked()) return;
      if (b && scope.contains(b)) applyAll(b.getAttribute('data-av-billing-opt'), scope);
    });
    scope.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-av-billing-opt]') || locked()) return;
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
      e.preventDefault();
      applyAll(scope.getAttribute('data-av-billing') === 'yearly' ? 'monthly' : 'yearly', scope, true);
    });
  }

  function run() { document.querySelectorAll('[data-av-billing-scope]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('av:billing:lock', function (e) {
    var m = e.detail && e.detail.mode;
    if (MODES[m]) applyAll(m);
  });
})();
